import { useMemo } from 'react';
import { useRoutesContext } from 'common/context/routes';
import { useCheckIsRoutesStationRecommendation } from 'common/context/routes';

import { checkIsActiveHereMap } from 'entities/map';

import { EMPTY_ARRAY } from 'shared/constants';

export const useActiveHereRouteStationRecomendationCodes = () => {
  const checkIsRoutesStationRecommendation = useCheckIsRoutesStationRecommendation();
  const { activeRoute } = useRoutesContext();

  const activeHereRouteStationRecomendationCodes = useMemo(() => (
    (activeRoute && checkIsActiveHereMap() ? activeRoute?.stationCodes || EMPTY_ARRAY : EMPTY_ARRAY).filter(stationCode => checkIsRoutesStationRecommendation(stationCode))
  ), [
    activeRoute,
    checkIsRoutesStationRecommendation
  ]);

  return activeHereRouteStationRecomendationCodes;
};
